import ErrorState from "src/Types/states/ErrorState";

const errorInitialState:ErrorState = [];

export default errorInitialState;
